import { connect } from 'react-redux';
import DashboardChargersList from './component';
import ColumnsSortService from '../../../../common/services/ColumnsSortService';
import { exportToCSV, getChargers, setColumnsConfig } from '../../../ChargersList/actions';
import APIClient from '../../../../common/services/APIClient';
import { wrapFilterForActiveOnly } from '../../actions';

const mapStateToProps = (state) => ({
  ...state.chargersList,
  user: state.login.user,
  config: state.appConfig.config,
  columnsConfig: state.chargersList.columnsConfig,
  filterQuery: state.ssplists?.dashboard?.filterQuery,
});

const mapDispatchToProps = (dispatch) => ({
  getColumnsConfig: async (config) => {
    const columnsOrder = await APIClient.get('/columns');
    const orderedColumns = ColumnsSortService.processDefaultSorting(columnsOrder, config);

    dispatch(setColumnsConfig(orderedColumns));
  },

  getChargers: (id, { ...args }) => dispatch(getChargers(id, { ...args, wrapFilter: wrapFilterForActiveOnly })),

  exportToCSV: (exportProps) => dispatch(exportToCSV(exportProps, wrapFilterForActiveOnly)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardChargersList);
